import { Component, Input, OnInit } from '@angular/core';
import { ControlService } from 'src/app/services/control.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-device-context-menu',
    templateUrl: './device-context-menu.component.html',
    styleUrls: ['./device-context-menu.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule]
})
export class DeviceContextMenuComponent implements OnInit {
  
  @Input() device:any;
  @Input() control:ControlService;
  
  ngOnInit(): void {
    window.onbeforeunload=null;
  }
}
